import { Row, Col } from "rsuite";
import { DashCircle, PlusCircle } from "react-bootstrap-icons";
import type { RegistLuggage } from "../../../../../my-type";

interface LuggageCounterProps {
  registLuggage: RegistLuggage;
  onIncrement: () => void;
  onDecrement: () => void;
}

export const LuggageCounter: React.FC<LuggageCounterProps> = ({
  registLuggage,
  onIncrement,
  onDecrement
}) => {
  return (
    <Row>
      <Col style={{ textAlign: 'left' }} xs={18}>{registLuggage.luggage.discription}</Col>
      <Col xs={2} style={{ textAlign: 'right' }}>
        <DashCircle style={{ fontSize: '20px' }} onClick={onDecrement} />
      </Col>
      <Col xs={1}>{registLuggage.quantity}</Col>
      <Col xs={2} style={{ textAlign: 'left' }}>
        <PlusCircle style={{ fontSize: '20px' }} onClick={onIncrement} />
      </Col>
    </Row>
  );
};
